import React, { lazy, Suspense, useEffect } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Row, Col } from 'antd'

import { APP_PAGES } from '../../../../../data/config/constants'
import { pageChanged } from '../../../../../data/redux/page_details/actions'
import { getIsMobile } from '../../../../../data/redux/page_details/selectors'
import { log } from '../../../../../data/config/utils'

import SpinnerLoader from '../../../../../components/spinnerloader'
import ApiLogsHeader from './ApiLogsHeader'

const ApiLogsList = lazy(() => import('./ApiLogsList'))
const ApiLogDetails = lazy(() => import('./ApiLogDetails'))


const APILogs = ({
  actions,
  is_mobile
}) => {
  log("APILogs rendered")

  const { pageChanged } = actions

  useEffect(() => {
    pageChanged(APP_PAGES.API_LOGS, APP_PAGES.CONSOLE)
  }, [])

  return (
    <div className="ori-bg-white ori-full-parent-height ori-flex-column">
      <ApiLogsHeader />
      <Row className="ori-full-flex ori-overflow-hidden">
        <Col
          xs={24}
          md={6}
          id="apiLogsItemsContainer"
          className="ori-r-border-light ori-full-parent-height ori-overflow-auto"
        >
          <Suspense fallback={<SpinnerLoader text="Loading" />}>
            <ApiLogsList />
          </Suspense>
        </Col>
        {
          !is_mobile &&
          <Col
            xs={24}
            md={18}
            className="ori-full-parent-height"
          >
            <Suspense fallback={<SpinnerLoader text="Loading" />}>
              <ApiLogDetails />
            </Suspense>
          </Col>
        }
      </Row >
    </div >
  )
}

const mapStateToProps = state => {
  return {
    is_mobile: getIsMobile(state),
  }
}

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(
      {
        pageChanged
      },
      dispatch
    )
  }
}

APILogs.propTypes = {
  actions: PropTypes.object,
  is_mobile: PropTypes.bool
}

export default connect(mapStateToProps, mapDispatchToProps)(APILogs)



// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/console/apilogs/index.js